import axios, { axiosWithCache } from "layouts/authentication/api/axios";

export const fetchPlans = async () => {
  try {
    const res = await axiosWithCache(`/plans`, "data");
    return res;
  } catch (error) {
    console.log(error);
  }
  return [];
};

export const fetchSpecialPlan = async (secret) => {
  try {
    const res = await axios().get(`/special-plan/${secret}`);
    return res.data;
  } catch (error) {
    console.log(error)
  }

  return null;
}

export const fetchSpecialPlans = async () => {
  try {
    const res = await axios().get(`/admin/special-plans`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
  return [];
};

export const sendSpecialPlan = async (data) => {
  try {
    const res = await axios().post(`/admin/send-special-plan`, {
      special_plan_id: data.planID,
      emails: data.emails,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }

  return null;
}
